import React from 'react';
import { ReaderPathCheck } from '../ReaderPathCheck';
interface QuickCheckProps {
  questionId: string;
  checkLabel?: string;
  confirmationText?: string;
}

/**
 * Light band wrapper for an inline ReaderPathCheck. Reuses the existing
 * component, question IDs, and scoring untouched.
 */
export function QuickCheck(props: QuickCheckProps) {
  return <section className="bg-paper px-6 py-6 md:py-8" data-id="element-820" data-mp="3n3bm2rcd17bk">
      <div className="mx-auto max-w-3xl md:max-w-4xl" data-id="element-821" data-mp="oo0zk03b4sq5">
        <ReaderPathCheck {...props} compact data-id="element-822" data-mp="olerlzci8b7e" />
      </div>
    </section>;
}